import { FC } from "react";

import { Report } from "@/modules";

const ReportPage: FC = () => {
  return (
    <div data-testid="report-page">
      <Report />
    </div>
  );
};

export default ReportPage;
